import { render, staticRenderFns } from "./ModalAddChapter.vue?vue&type=template&id=56005c18&scoped=true&"
import script from "./ModalAddChapter.vue?vue&type=script&lang=js&"
export * from "./ModalAddChapter.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddChapter.vue?vue&type=style&index=0&id=56005c18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56005c18",
  null
  
)

export default component.exports